'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentOverrides = styled.div.withConfig({
  displayName: "ContentText__ContentOverrides",
  componentId: "sc-11x3cwc-0"
})(["word-wrap:break-word;overflow-x:auto;white-space:", ";line-height:1.5;img{max-width:100%;height:auto;}.display-none{display:none;}h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:bold;}pre{overflow:visible;}"], ({
  isPlainText
}) => isPlainText && 'pre-wrap');
export default class ContentText extends PureComponent {
  render() {
    const {
      className,
      contentText,
      isPlainText,
      isShowingMessageReplies,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_jsx(ContentOverrides, {
      className: className,
      isPlainText: isPlainText,
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: contentText,
        textSeleniumKey: dataTestId,
        formattingOptions: {
          isPlainText,
          shouldIncludeFullSizeImages: true,
          shouldRemoveGmailLineBreakBeforeReply: true,
          shouldRemoveEmailSignature: !isShowingMessageReplies,
          shouldIncludeReplies: isShowingMessageReplies,
          shouldOpenLinksInNewTab: true
        }
      })
    });
  }
}
ContentText.displayName = 'ContentText';
ContentText.propTypes = {
  className: PropTypes.string,
  contentText: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  isPlainText: PropTypes.bool,
  isShowingMessageReplies: PropTypes.bool
};
ContentText.defaultProps = {
  dataTestId: 'primary-message-content',
  isPlainText: false
};